// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var alertBanner = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.textAlign("center"),
      BsCssJs$PrezzeeRibbon.minHeight(BsCssJs$PrezzeeRibbon.px(35))
    ]);

var blueBanner = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.activeBlue)]);

var yellowBanner = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.yellow)]);

var orangeBanner = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.orange)]);

var greenBanner = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.green)]);

var redBanner = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.primaryRed)]);

function customHexBanner(customColor) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor({
                    NAME: "hex",
                    VAL: customColor
                  })]);
}

function customRGBBanner(a, b, c) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgb(a, b, c))]);
}

function customRGBABanner(a, b, c, d) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgba(a, b, c, {
                        NAME: "num",
                        VAL: d
                      }))]);
}

var Styles = {
  alertBanner: alertBanner,
  blueBanner: blueBanner,
  yellowBanner: yellowBanner,
  orangeBanner: orangeBanner,
  greenBanner: greenBanner,
  redBanner: redBanner,
  customHexBanner: customHexBanner,
  customRGBBanner: customRGBBanner,
  customRGBABanner: customRGBABanner
};

function AlertBanner(props) {
  var optionalStyles = props.optionalStyles;
  var alertColour = props.alertColour;
  var optionalStyles$1 = optionalStyles !== undefined ? optionalStyles : "";
  var alertColourClassName;
  if (typeof alertColour === "number") {
    switch (alertColour) {
      case /* Blue */0 :
          alertColourClassName = blueBanner;
          break;
      case /* Green */1 :
          alertColourClassName = greenBanner;
          break;
      case /* Red */2 :
          alertColourClassName = redBanner;
          break;
      case /* Orange */3 :
          alertColourClassName = orangeBanner;
          break;
      case /* Yellow */4 :
          alertColourClassName = yellowBanner;
          break;
      
    }
  } else {
    alertColourClassName = alertColour._0;
  }
  var className = Classnames([
        alertBanner,
        alertColourClassName,
        optionalStyles$1
      ]);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: className
            });
}

var make = AlertBanner;

export {
  Styles ,
  make ,
}
/* alertBanner Not a pure module */
